// Initialize gtag
export const gtag = (...args: any[]) => {
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag(...args);
  }
};

// Track events
export const event = ({
  action,
  properties,
}: {
  action: string;
  properties: Record<string, any>;
}) => {
  gtag("event", action, {
    ...properties,
  });
};
